import { TCopyFormat } from "../types";

export const handleCopyToClipboard = (
  ref: React.RefObject<HTMLDivElement>,
  format: TCopyFormat
) => {
  const element = ref.current;

  if (!element) return;

  const textContent = element.innerText || element.textContent || "";
  const htmlContent = element.innerHTML;

  if (format === "text") {
    navigator.clipboard.writeText(textContent);
    return;
  }

  if (format === "html") {
    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([htmlContent], { type: "text/html" }),
      }),
    ]);
    return;
  }

  if (format === "both") {
    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([htmlContent], { type: "text/html" }),
        "text/plain": new Blob([textContent], { type: "text/plain" }),
      }),
    ]);
    return;
  }
};
